<template>
   <div
      v-for="(pageSection, psIndex) in contentSectionsList"
      :key="`page-section-${psIndex}`"
      :class="[`page-section-margin-${pageSection.margin}`]"
   >
      <div :data-cy="`page-section-${psIndex}`">
         <component :is="pageSectionComponents[pageSection.type]" v-bind="pageSection"></component>
      </div>
   </div>
</template>

<script setup lang="ts">
// dynamic page components
import HeroSection from "@/components/pageSection/hero/HeroSection.vue";
import GreetingSection from "@/components/pageSection/hero/GreetingSection.vue";
import TextSection from "@/components/pageSection/text/TextSection.vue";
import CarouselSection from "@/components/pageSection/CarouselSection.vue";
import FootNotesSection from "@/components/pageSection/FootNotesSection.vue";
import FAQSection from "@/components/pageSection/faq/FAQSection.vue";
import CardsContainer from "@/components/cards/CardsContainer.vue";
import TextImageSection from "@/components/pageSection/text-image/TextImageSection.vue";
import IFrameSection from "@/components/pageSection/iFrameSection.vue";
import RichTextRenderer from "@/components/richText/RichTextRenderer.vue";

// dynamic component types
// -----------------------------------------
const pageSectionComponents = {
   hero_section: HeroSection,
   text_section: TextSection,
   carousel_section: CarouselSection,
   footnotes_section: FootNotesSection,
   faq_section: FAQSection,
   cards_section: CardsContainer,
   text_image_section: TextImageSection,
   greeting_section: GreetingSection,
   iframe_section: IFrameSection,
   richtext_section: RichTextRenderer,
};

//props
// -----------------------------------------
interface Props {
   contentSections: any;
}

const props = withDefaults(defineProps<Props>(), {});

// computed
// -----------------------------------------
const contentSectionsList = computed(() => {
   return props.contentSections.map((pageSection: any) => {
      return {
         ...pageSection,
         margin: pageSection.margin || "none", // set margin to none if not defined
      };
   });
});
</script>

<style lang="scss" scoped>
// page section margins
.page-section-margin {
   &-none {
      @apply my-0;
   }
   &-sm {
      @apply my-4;
   }
   &-md {
      @apply my-6;
   }
   &-lg {
      @apply my-16;
   }
}
</style>
